<template>
  <b-button class="bt101" size="lg" pill>
    <slot/>
  </b-button>
</template>

<script>
export default {
  name: "Bt101"
}
</script>

<style scoped>
.bt101 {
  background-color: var(--light-red) !important;
  color: white !important;
  border: none;
}

.bt101:hover {
  background-color: transparent !important;
  border: 3px dashed white !important;
  color: white !important;
  font-weight: bold;
}
</style>